import { render, staticRenderFns } from "./outside-wx.vue?vue&type=template&id=11a7e41a&scoped=true&"
import script from "./outside-wx.vue?vue&type=script&lang=ts&"
export * from "./outside-wx.vue?vue&type=script&lang=ts&"
import style0 from "./outside-wx.vue?vue&type=style&index=0&id=11a7e41a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a7e41a",
  null
  
)

export default component.exports